function fireShopfloAnalyticsEvent(platform, merchantID) {
  let payload = {
    eventName: "checkout_clicked",
    sessionId: window.Shopflo.getSessionId(),
    timestamp: +new Date(),
    merchantId: merchantID,
    eventPayload: {
      uiData: {
        source: platform
      },
      clientData: {
        clientIp: window.Shopflo.clientMeta.client_ip,
        userAgent: window.Shopflo.clientMeta.user_agent,
      },
    },
    eventType: "click",
    channel: "web",
  };

  if (navigator?.sendBeacon && Blob) {
    let blob = new Blob([JSON.stringify(payload)]);
    navigator.sendBeacon('https://hits.shopflo.com/api/v1/spark', blob);
  }
}

function getCookie(name) {
  let match = document.cookie.match(RegExp("(?:^|;\\s*)" + name + "=([^;]*)"));
  return match ? match[1] : null;
}
function isFloEnabled() {
  let num = Math.random();
  if (num < 0.5) return "shopflo";
  else return "default";
}

function openCheckout() {
  if (getCookie("flo_checkout_enabled") === "shopflo") {
    handleFloCheckoutBtn();
  } else {
    fireShopfloAnalyticsEvent("shopify", "18b1ee8c-7097-4831-9311-65f13f9ccefc");
    window.location.href = "/checkout";
  }
}

function displaySelectedButton() {
  if (getCookie("flo_checkout_enabled") === "shopflo") {
    document
      .querySelector("#shopflo_buy_now_button_wrapper")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#shopify_buy_now_button_wrapper")
      .style.setProperty("display", "none", "important");
  } else {
    document
      .querySelector("#shopify_buy_now_button_wrapper")
      .style.setProperty("display", "block", "important");
    document
      .querySelector("#shopflo_buy_now_button_wrapper")
      .style.setProperty("display", "none", "important");
  }
}

if (getCookie("flo_checkout_enabled") == null) {
  let today = new Date();
  let expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 14);
  document.cookie =
    "flo_checkout_enabled=" +
    isFloEnabled() +
    ";path=/" +
    ";expires=" +
    expire.toGMTString();
}

document.addEventListener("DOMContentLoaded", function () {
  displaySelectedButton();
});